export default {
    API_ENDPOINT: `https://nameless-stream-95178.herokuapp.com/api`,
}